import { render, staticRenderFns } from "./ApiSmsTemplate.vue?vue&type=template&id=4de8f3f2&scoped=true"
import script from "./ApiSmsTemplate.vue?vue&type=script&lang=js"
export * from "./ApiSmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ApiSmsTemplate.vue?vue&type=style&index=0&id=4de8f3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8f3f2",
  null
  
)

export default component.exports